// Service pour traduire les réponses
// Note: Pour une vraie traduction, il faudrait utiliser une API de traduction
// Ici, on simule avec des traductions basiques ou on utilise l'API du navigateur

export type Language = 'fr' | 'ar' | 'en';

class TranslationService {
  private currentLanguage: Language = 'fr';

  setLanguage(lang: Language): void {
    this.currentLanguage = lang;
    localStorage.setItem('chat_language', lang);
  }

  getLanguage(): Language {
    const saved = localStorage.getItem('chat_language') as Language;
    return saved || 'fr';
  }

  // Traduire un texte (version simplifiée - pour une vraie traduction, utiliser une API)
  async translate(text: string, targetLang: Language): Promise<string> {
    if (targetLang === 'fr') {
      return text; // Déjà en français
    }

    // Pour l'arabe et l'anglais, on pourrait utiliser l'API de traduction du navigateur
    // ou une API externe comme Google Translate API
    // Pour l'instant, on retourne le texte original avec une note
    if (targetLang === 'ar') {
      // Détecter si le texte contient déjà de l'arabe
      const hasArabic = /[\u0600-\u06FF]/.test(text);
      if (hasArabic) {
        return text; // Déjà en arabe
      }
      // Sinon, on pourrait appeler une API de traduction
      return text; // Placeholder - à implémenter avec une vraie API
    }

    if (targetLang === 'en') {
      // Placeholder pour la traduction anglaise
      return text; // Placeholder - à implémenter avec une vraie API
    }

    return text;
  }

  // Obtenir le nom de la langue
  getLanguageName(lang: Language): string {
    const names: Record<Language, string> = {
      fr: 'Français',
      ar: 'العربية',
      en: 'English',
    };
    return names[lang];
  }

  // Obtenir l'icône de la langue
  getLanguageIcon(lang: Language): string {
    const icons: Record<Language, string> = {
      fr: '🇫🇷',
      ar: '🇸🇦',
      en: '🇬🇧',
    };
    return icons[lang];
  }
}

export const translationService = new TranslationService();







